import { render } from "./MyCreationsView.vue?vue&type=template&id=c85dc814&scoped=true"
import script from "./MyCreationsView.vue?vue&type=script&lang=js"
export * from "./MyCreationsView.vue?vue&type=script&lang=js"

import "./MyCreationsView.vue?vue&type=style&index=0&id=c85dc814&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85dc814"]])

export default __exports__